export const config = {
    bullets: {
        options: {
            animated: false,
            type: "dot",
        },
        /**
         * Инициализация анимированных буллетов пагинации
         * @param { Object } slider - текущий слайдер
         */
        init(slider) {
            const bullets = slider.pagination.bullets;
            if (bullets) {
                bullets[0].classList.add("c-slider-animated");
            }
        },
        /**
         * Анимация буллетов пагинации при изменении слайдов
         * @param { Object } slider - текущий слайдер
         */
        animate(slider) {
            const bullets = slider.pagination.bullets;
            bullets[slider.activeIndex].classList.add("c-slider-animated");
            bullets[slider.previousIndex].classList.remove("c-slider-animated");
        },
        innerHTML: `
            <div class="circle">
                <div class="circle__mask on-left">
                    <div class="circle__inner"></div>
                </div>
                <div class="circle__mask on-right">
                    <div class="circle__inner"></div>
                </div>
                <div class="circle__holder"></div>
            </div>`,
    },
};
